<template>
  <el-autocomplete style="width:100%"
    v-model="street" :trigger-on-focus="triggerOnFocus"
    :disabled="disabled"
    :fetch-suggestions="autoCompleteApi"
    :placeholder="placeholder()" suffix-icon="el-icon-search"
    @select="placeDetailApi">
  </el-autocomplete>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
/* eslint handle-callback-err: "off" */

import request from '@/utils/request'
import { uuid } from 'vue-uuid'

export default {
  props: {
    code: {
      type: String,
      default: 'address'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    search: String
  },
  computed: {
    street: {
      get: function () {
        return this.search
      },
      set: function (value) {
        this.$emit('update:search', value)
      }
    }
  },
  data: function () {
    return {
      triggerOnFocus: false,
      predictions: [],
      loading: false,
      address: '',
      session_token: ''
    }
  },
  created () {
    this.initSessionToken()
  },
  methods: {
    placeholder () {
      let ret = this.$t('employee.lbl.address.street')
      switch (this.code) {
        case 'city':
          ret = this.$t('employee.lbl.address.city')
          break
        case 'address':
          ret = this.$t('employee.lbl.address_txt')
          break
      }
      return ret
    },
    initSessionToken () {
      this.session_token = uuid.v4()
    },
    autoCompleteApi (p_value, callback) {
      request({
        url: '/google/place/autocomplete/' + this.session_token + '/' + p_value,
        method: 'get'
      })
        .then(resp => {
          let results = []
          resp.data.predictions.map(item => {
            results.push({value: item.description, place_id: item.place_id})
          })
          callback(results)
        })
        .catch(err => {
        })
    },
    placeDetailApi (p_value) {
      request({
        url: '/google/place/detail/' + this.session_token + '/' + p_value.place_id,
        method: 'get'
      })
        .then(resp => {
          this.street = resp.data.street + ' ' + resp.data.street_number
          this.$emit('complete', resp.data)
          this.initSessionToken()
        })
        .catch(err => {
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HMGoogleAddress/index.vue